import type { Role } from '#dn-types/role.ts';
import type { FormData } from '../types.ts';
import { mapFirewallRulesToRoleForm } from './mapFirewallRulesToRoleForm.ts';

/**
 * Maps a {@link Role} from the api into {@link RoleDetailForm} default values.
 */
export function mapRoleToForm(role: Role): FormData {
  return {
    roleName: role.name,
    roleDescription: role.description,
    firewallRules: mapFirewallRulesToRoleForm(role.firewallRules),
  };
}
